import React from "react";
import DMModuleSubtopic from "../DMModuleSubtopic";

const EulerHamiltonModule = () => (
  <DMModuleSubtopic
    title="Eulerian and Hamiltonian Graphs"
    videos={[
      "https://www.youtube.com/embed/9peq9HBU0D0"
    ]}
    takeaways={[]}
    questions={[
      {
        text: "Explain Eulerian but not Hamiltonian Graph and vice versa with suitable examples."
      },
      {image:"/dm_35.png"},
    ]}
    exampleVideos={[]}
  />
);

export default EulerHamiltonModule;
